import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { CheckEmailUseCase, IdInterface } from '../../../core';

export const emailExists = (required: boolean, checkEmailUseCase: CheckEmailUseCase, clientCode?: IdInterface): AsyncValidatorFn => {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
        const v: string = control.value;

        if (!required) {
            return of(null);
        }

        return checkEmailUseCase.bind(v, clientCode).pipe(
            debounceTime(400),
            distinctUntilChanged(),
            map((transaction) => {
                return transaction.isSuccess && transaction.data ? { emailExists: true } : null;
            })
        );
    };
};
